var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_7343)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0011 0.909102C18.2611 0.909337 21.4201 2.03992 23.94 4.10821C26.4599 6.1765 28.1846 9.05453 28.8204 12.2519C29.4562 15.4493 28.9636 18.7682 27.4267 21.6432C25.8898 24.5182 23.4035 26.7713 20.3916 28.0186C17.3797 29.266 14.0285 29.4304 10.9089 28.4839C7.78937 27.5374 5.0945 25.5385 3.2835 22.8278C1.4725 20.1171 0.657419 16.8624 0.977127 13.6181C1.29684 10.3738 2.73156 7.34077 5.03684 5.03572C6.3439 3.72528 7.89709 2.68609 9.6071 1.9779C11.3171 1.26971 13.1502 0.906487 15.0011 0.909102ZM5.81281 23.0909C6.66734 21.3886 7.97904 19.9579 9.60092 18.959C11.2228 17.9602 13.0908 17.4328 14.9955 17.4358C16.9003 17.4389 18.7666 17.9722 20.3853 18.9762C22.0039 19.9802 23.3111 21.4151 24.1602 23.1201C25.7242 21.3563 26.7458 19.1785 27.1022 16.8482C27.4586 14.5179 27.1347 12.1343 26.1694 9.9836C25.204 7.83292 23.6384 6.00665 21.6604 4.72413C19.6824 3.44161 17.3763 2.75739 15.0189 2.75363C12.6615 2.74988 10.3532 3.42675 8.37116 4.70297C6.38911 5.97918 4.81764 7.80046 3.84549 9.94804C2.87334 12.0956 2.54184 14.4782 2.89082 16.8096C3.23981 19.141 4.25442 21.3221 5.81281 23.0909ZM15.0238 4.58442C13.7258 4.5846 12.4681 5.03483 11.4648 5.8584C10.4616 6.68196 9.77495 7.82791 9.52189 9.10098C9.26883 10.3741 9.46501 11.6955 10.077 12.8401C10.689 13.9848 11.679 14.8818 12.8782 15.3784C14.0775 15.875 15.4118 15.9404 16.6538 15.5634C17.8959 15.1865 18.9688 14.3906 19.6898 13.3113C20.4108 12.232 20.7353 10.936 20.6079 9.64432C20.4806 8.3526 19.9093 7.145 18.9914 6.22728C18.4704 5.70776 17.8521 5.29609 17.1719 5.01586C16.4916 4.73563 15.7628 4.59233 15.0271 4.59416L15.0238 4.58442Z",
    fill: "#1b4597"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_7343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.519939854215ff1ab4db6b0518a4cbdc.svg";
export { ForwardRef as ReactComponent };